import React, {useState} from 'react'
import { FaBars,FaUser } from "react-icons/fa";
import './Navbar.css'
import logo from './photo-output.PNG'
import { Link,useNavigate } from 'react-router-dom'
import axios from '../api/api'

const Nav = () => {

  const [search, setSearch] = useState('')
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const [token, setToken] = useState(!!window.localStorage.getItem('token'));

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await axios.get('/api/v3/search', {
        params: { q: search }
      });
      setSearch(response)
      navigate('/search-results', { state: { searchResults: response.data } })
    } catch (error) {
      console.error('Error during search:', error);
    }
  }

  // logout
  const navigate = useNavigate()
  const signOut = () => {
    window.localStorage.removeItem('token');
    setToken(false)
    navigate('/')
  };


  return (
    <main className="nav">
      <div className="bg-[#144184] text-white">
        <div className="mx-auto p-4 lg:container">
          <nav className='flex flex-wrap justify-between items-center px-4'>
            {/* Top Nav */}
            <div className='flex items-center gap-4'>
              <Link to='/'><img width={50} height={50} src={logo} className='h-15' alt="" /></Link>
              <div >
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                  <li className="nav-item">
                    <a href="/home" className="nav-links">HOME</a>
                  </li>
                  <li className="nav-item">
                    <a href="/movies" className="nav-links">MOVIES</a>
                  </li>
                  <div className='dropdown'>
                    <a className='dropdown-toggle p-2 transition duration-150 ease-in-out flex items-center justify-center whitespace-nowrap' href='/#' type='button' id='dropdownMenuButton2' data-bs-toggle='dropdown' aria-expanded='false'>
                      <span>GENRE</span>
                      <svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='caret-down' className='w-2 ml-2'  xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
                        <path fill='currentColor' d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z' />
                      </svg>
                    </a>
                    <ul className='dropdown-menu absolute bg-white z-50 float-left  py-2  rounded-lg  shadow-lg  mt-1 hidden m-0 w-full lg:w-1/12' aria-labelledby='dropdownMenuButton2'>
                      <li>
                        <a className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-200' href='/action'>ACTION</a>
                      </li>
                      <li>
                        <a className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-200' href='/drama'>DRAMA</a>
                      </li>
                      <li>
                        <a className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-200' href='/comedy'>COMEDY</a>
                      </li>
                      <li>
                        <a className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-200' href='/romance'>ROMANCE</a>
                      </li>
                    </ul>
                  </div>
                  {token ? (
                    <div></div>
                  ) : (
                    <div>
                      <li className="nav-item">
                      <a href="/creator/creator-register" className="nav-links">CREATE ACCOUNT</a>
                    </li>
                    </div>
                  )}
                </ul>
              </div>
            </div>
            <div className='nav-social hidden md:flex items-center space-x-2'>
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="relative flex items-center">
                  <button className='absolute mb-0.5 right-3'>
                      <svg className='text-green-600 h-6 w-6 hover:text-green-400' viewBox='0 0 20 20' fill='currentColor'>
                        <path fillRule='evenodd' d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z' clipRule='evenodd' />
                      </svg>
                    </button>
                    <label htmlFor="search">
                      <input 
                        type="text" 
                        className='ml-2 px-3 py-1 bg-white text-black border rounded-full border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-96 focus:ring-1'
                        placeholder="Search..." 
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </label>                    
                  </div>
                </form>
              </div>
              {token ? (
                <div className='dropdown'>
                  <a className='dropdown-toggle p-2 transition duration-150 ease-in-out flex items-center whitespace-nowrap ' href='/#' type='button' id='dropdownMenuButton2' data-bs-toggle='dropdown' aria-expanded='false'>
                  <label htmlFor="my-drawer-4" className='gap-1 text-3xl hover:text-slate-300'><FaUser /></label>
                    <svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='caret-down' className='w-2 ml-2'  xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
                      <path fill='currentColor' d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z' />
                    </svg>
                  </a>
                  <ul className='dropdown-menu min-w-max absolute  bg-white text-base z-50 float-left  py-2 list-nonetext-left  rounded-lg  shadow-lg  mt-1 hidden m-0 bg-clip-padding border-none' aria-labelledby='dropdownMenuButton2'>
                    <div className='text-black px-4 py-0.5'>
                      <h4>Recommended actions</h4>
                    </div>
                    <li>
                      <a className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-100' href='/viewer/profile'>Profile</a>
                    </li>
                    <li>
                      <a onClick={signOut} className='dropdown-item text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-gray-700  hover:bg-gray-100' href='/'>Log Out</a>
                    </li>
                  </ul>
                </div>
              ) : (
                <div>
                  <Link to='/user-login' className='gap-1 text-3xl hover:text-slate-300'><FaUser /></Link>
                </div>
              )}
            </div>
            <button className="nav-icon" onClick={handleClick}>
              <span><FaBars/></span>
            </button>
          </nav>
        </div>
      </div> 
    </main>
  )
}

export default Nav